import { render, staticRenderFns } from "./employeeInsurance.vue?vue&type=template&id=c1a80820&"
import script from "./employeeInsurance.vue?vue&type=script&lang=js&"
export * from "./employeeInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports